import { Controller } from 'react-hook-form';
import SearchInput from '@/components/searchInput';

function SearchInputController({
  className,
  searchId,
  searchName,
  callBack,
  options,
  handleSelectOption,
  control,
  rules,
  placeholder,
  searching,
}) {
  return (
    <Controller
      name={searchId}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        formState: { errors },
      }) => (
        <SearchInput
          className={className}
          placeholder={placeholder}
          name={searchName}
          instanceId={searchId}
          searchRequest={callBack}
          options={options}
          onChange={(address) => {
            onChange(address);
            handleSelectOption(address);
          }}
          value={value}
          error={errors?.[searchId]?.message || ''}
          onBlur={onBlur}
          searching={searching}
        />
      )}
    />
  );
}
export default SearchInputController;
